import { Field } from '@/api/types/crm.types'
import { z, ZodSchema } from 'zod'

// Валидация по unique_name
const uniqueNameValidations: Record<string, ZodSchema> = {
  // NAME: z
  //   .string({
  //     required_error: 'Обязательное поле',
  //   })
  //   .trim()
  //   .min(1, 'Обязательное поле')
  //   .max(100, 'Максимум 100 символов'),
  PHONE: z
    .string({
      required_error: 'Обязательное поле',
    })
    .trim()
    .min(1, 'Обязательное поле')
    .regex(
      /^\+?[1-9]\d{6,14}$/,
      'Неверный формат номера телефона (+79991234567)',
    ),
  // если добавляем сюда, проверка по typeValidations отключается
}

// Валидация по type
const typeValidations: Record<string, ZodSchema> = {
  number: z
    .string()
    .transform((val) => (val === '' ? undefined : val))
    .optional()
    .transform((val) => (val !== undefined ? Number(val) : undefined))
    .refine((val) => val === undefined || !isNaN(val), 'Должно быть числом'),

  textfield: z
    .string()
    .transform((val) => (val === '' ? undefined : val))
    .optional()
    .refine(
      (val) => val === undefined || val.length <= 200,
      'Максимум 200 символов',
    ),

  textarea: z
    .string()
    .transform((val) => (val === '' ? undefined : val))
    .optional()
    .refine(
      (val) => val === undefined || val.length <= 1000,
      'Максимум 1000 символов',
    ),
  select: z.string().optional(),
  datetime: z
    .string()
    .transform((val) => (val === '' ? undefined : val))
    .optional()
    .refine(
      (val) => val === undefined || !isNaN(Date.parse(val)),
      'Неверный формат даты',
    ),
  phone_number: z
    .string()
    .transform((val) => (val === '' ? undefined : val))
    .optional()
    .refine(
      (val) => val === undefined || /^\+?[1-9]\d{6,14}$/.test(val),
      'Неверный формат номера телефона (+79991234567)',
    ),
}
// Поля которые не должны попасть в форму, или не должны проверяться
export const ignoreLeadFields = ['ID', 'STATUS', 'DATEL', 'DATEZ', 'DATEN']

type Data = Record<string, string>

export const validateForm = (
  formData: Data,
  fields: Field[],
  needCheckIsRequired: boolean = true,
): true | Data => {
  const fieldErrors: Record<string, string> = {}

  // Сначала проверяем is_required поля
  if (needCheckIsRequired) {
    fields.forEach((field) => {
      if (field.is_active && field.is_required) {
        const rawValue = formData[field.unique_name]
        const value =
          rawValue === null || rawValue === undefined
            ? ''
            : String(rawValue).trim()
        if (value === '') {
          fieldErrors[field.unique_name] = 'Обязательное поле'
        }
      }
    })
  }

  const schemaObject: Record<string, ZodSchema> = {}

  // Проверяем по uniqueNameValidations или typeValidations
  fields.forEach((field) => {
    if (field.is_active) {
      const schema =
        uniqueNameValidations[field.unique_name] ||
        typeValidations[field.type] ||
        z.string().optional()
      schemaObject[field.unique_name] = schema
    }
  })

  const schema = z.object(schemaObject)
  const result = schema.safeParse(formData)

  if (result.success && Object.keys(fieldErrors).length === 0) return true

  if (!result.success) {
    result.error.errors.forEach((err) => {
      const path = err.path[0] as string
      fieldErrors[path] = err.message
    })
  }

  return fieldErrors
}
